import { render, staticRenderFns } from "./GemstoneReport1920.vue?vue&type=template&id=323c979e&scoped=true"
import script from "./GemstoneReport1920.vue?vue&type=script&lang=js"
export * from "./GemstoneReport1920.vue?vue&type=script&lang=js"
import style0 from "./GemstoneReport1920.vue?vue&type=style&index=0&id=323c979e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323c979e",
  null
  
)

export default component.exports